import { HeroIcon } from '@components/HeroIcon'
import { Animated } from 'react-native'
import { XStack, Text } from 'tamagui'

const BADGE_CONFIG = {
  buy: {
    testID: 'buy-tag',
    backgroundColor: '$cross-500',
    icon: 'bag-shopping' as const,
    iconColor: '$text-on-media',
    textColor: '$text-on-media',
    px: 12,
    py: 4,
    responsivePadding: false,
    textResponsive: { $gtLg: { fontSize: 14 } },
  },
  lock: {
    testID: 'lock-badge',
    backgroundColor: '$bg-locked',
    icon: 'lock-keyhole' as const,
    iconColor: '$text-on-locked',
    textColor: '$text-on-locked',
    px: 8,
    py: 2,
    responsivePadding: true,
    textResponsive: { $gtLg: { fontSize: 14 } },
  },
  live: {
    testID: 'live-badge',
    backgroundColor: '$danger-300',
    icon: 'signal-stream' as const,
    iconColor: '$text-on-media',
    textColor: '$text-on-media',
    px: 8,
    py: 2,
    responsivePadding: true,
    textResponsive: { $gtMd: { fontSize: 14 } },
  },
} as const

interface IProductBadgeProps {
  variant: keyof typeof BADGE_CONFIG
  badgeIconSize: number
  label: string
  interpolatedOpacity?: Animated.AnimatedInterpolation<number>
}

export function ProductBadge({
  variant,
  badgeIconSize,
  label,
  interpolatedOpacity,
}: IProductBadgeProps) {
  const config = BADGE_CONFIG[variant]

  const iconElement = (
    <HeroIcon
      icon={['fal', config.icon]}
      color={config.iconColor}
      size={badgeIconSize}
    />
  )

  return (
    <XStack
      position="absolute"
      testID={config.testID}
      right={12}
      top={12}
      alignItems="center"
      gap={8}
      backgroundColor={config.backgroundColor}
      px={config.px}
      py={config.py}
      borderRadius={999}
      {...(config.responsivePadding && { $gtSm: { py: 4, px: 12 } })}
    >
      {variant === 'live' && interpolatedOpacity ? (
        <Animated.View style={{ opacity: interpolatedOpacity }}>
          {iconElement}
        </Animated.View>
      ) : (
        iconElement
      )}
      <Text
        ff="$mulishSemiBold"
        color={config.textColor}
        fontSize={12}
        fontWeight={600}
        {...(variant === 'live' && { paddingBottom: 1.5 })}
        {...config.textResponsive}
      >
        {label}
      </Text>
    </XStack>
  )
}
